module.exports = __webpack_public_path__ + "../resources/img/main_contents_bg.a78dc2a5.png";